import { NgModule } from "@angular/core";
import { BanderaPaisComponent } from "./bandera-pais/bandera-pais.component";
import { ItemCardFlechaComponent } from "./item-card-flecha/item-card-flecha.component";
import { SvgIconComponent } from "./svg-icon/svg-icon.component";
import { NgxCommandModule } from "@nahuelmorata/ngx-command";
import { ModalDecisionComponent } from "./modal-decision/modal-decision.component";
import {
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbTimepickerModule
} from "@ng-bootstrap/ng-bootstrap";
import { ModalInputComponent } from "./modal-input/modal-input.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalErrorComponent } from "./modal-error/modal-error.component";
import { ModalSuccessComponent } from "./modal-success/modal-success.component";
import {
    VerificacionModalComponent
} from "../../layout/panelistas/panelistas-detalle/columna-izquierda/datos-verificacion/verificacion-modal/verificacion-modal.component";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { ModalPruebaInternaComponent } from "./modal-prueba-interna/modal-prueba-interna.component";
import { NgxPhotoEditorComponent } from "./photo-editor/ng-photo-editor.component";
import { StarComponent } from "./star/star.component";
import {
    ModalInvestigacionDatosBasicosComponent
} from "./modal-investigacion-datos-basicos/modal-investigacion-datos-basicos.component";
import { ModalInfoComponent } from "./modal-info/modal-info.component";
import { RouterModule } from "@angular/router";
import {
    CanjesModalErrorComponent
} from "../../layout/canjes/canjes-lista/canjes-modal/canjes-modal-error/canjes-modal-error.component";
import { SharedModule } from "@shared";
import { ModalDateComponent } from "./modal-date/modal-date.component";
import { LoaderComponent } from "./loader/loader.component";
import { ModalAccionesItemComponent } from "./modal-acciones-item/modal-acciones-item.component";
import { ModalBitacoraComponent } from "./modal-bitacora/modal-bitacora.component";
import { ModalInfiniteSpinnerComponent } from "./modal-infinite-spinner/modal-infinite-spinner.component";
import { MonthPickerComponent } from "./month-picker/month-picker.component";
import { GraficoCasosDuplicadosComponent } from "./grafico-casos-duplicados/grafico-casos-duplicados.component";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { DropzoneComponent } from "./dropzone/dropzone.component";
import { DropzoneCdkModule } from "@ngx-dropzone/cdk";
import { DropzonePreviewComponent } from "./dropzone/dropzone-preview/dropzone-preview.component";
import { LabelPreviewDropzoneDirective } from "./dropzone/directives/label-preview-dropzone/label-preview-dropzone.directive";

@NgModule({
    declarations: [
        ItemCardFlechaComponent,
        SvgIconComponent,
        BanderaPaisComponent,
        ModalDecisionComponent,
        ModalInputComponent,
        ModalErrorComponent,
        ModalSuccessComponent,
        VerificacionModalComponent,
        ModalPruebaInternaComponent,
        NgxPhotoEditorComponent,
        StarComponent,
        ModalInfoComponent,
        ModalInvestigacionDatosBasicosComponent,
        CanjesModalErrorComponent,
        ModalDateComponent,
        LoaderComponent,
        ModalAccionesItemComponent,
        ModalBitacoraComponent,
        ModalInfiniteSpinnerComponent,
        MonthPickerComponent,
        GraficoCasosDuplicadosComponent,
        DropzoneComponent,
        DropzonePreviewComponent,
        LabelPreviewDropzoneDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModalModule,
        NgbDropdownModule,
        NgxCommandModule,
        NgSelectModule,
        RouterModule,
        SharedModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        NgOptimizedImage,
        NgbCollapseModule,
        NgxChartsModule,
        DropzoneCdkModule
    ],
    exports: [
        ItemCardFlechaComponent,
        SvgIconComponent,
        BanderaPaisComponent,
        NgxPhotoEditorComponent,
        StarComponent,
        LoaderComponent,
        MonthPickerComponent,
        GraficoCasosDuplicadosComponent,
        DropzoneComponent,
        LabelPreviewDropzoneDirective
    ]
})
export class ComponentsModule {}
